import PreviewStylesCss from "../../styles/PreviewStyles.css";
import TableStyles from "../../styles/TableStyles.css";
import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...PreviewStylesCss,
  ...TableStyles,
  ...CommonStyles,



  globalInput: {
    width: "100%",
    padding: "0",
    "& input": {
      borderRadius: "5px !important",
      padding: "10px",
      fontSize: "0.8em",
      margin: "0",
      background: "#00405f !important",
    },
    "&  div": {
      borderRadius: "5px",
      padding: "0 !important",
      "&:after": {
        borderBottom: "none !important",
      },
      "&:before": {
        borderBottom: "none !important",
      },

    },
    "& > div .MuiFormControl-root": {
      background: "#00405f !important",
      width: "100%",

    },
    "& div.MuiAutocomplete-endAdornment": {
      width: "auto !important",
    },
    "& div.MuiCircularProgress-indeterminate": {
      width: "20px !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "& .MuiChip-root": {
      margin: "3px !important",
      backgroundColor: "#001b33",
      padding: "3px !important",
      height: "auto",
      "& > span": {
        whiteSpace: "normal",
        wordBreak: "break-all",
        lineHeight: "12px",
      },
      "&.Mui-focusVisible": {
        backgroundColor: "#446888",
      },
    },
    "&  .MuiAutocomplete-inputRoot": {
      padding: " 2px 9px",
    },
    "&:before": {
      display: "none",
    },
    "&:after": {
      borderBottom: " 2px solid #11a54e",
    },
    "& .contributorItems": {
      padding: "10px !important",
      background: "#1f4163",
      marginBottom: "10px",
    }
  },

  muDetails: {
    width: "80%",
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "0.75em",
    wordBreak: "break-word",
  },
  muLabelsBold: {
    fontWeight: "bold",
  },

  muDetailsBold: {
    fontWeight: "bold",
  },
  uploadPreview: {
    background: "#1F364D",
    "& .MuiPaper-root": {
      background: "#1F364D",
      "& > div": {
        // background:"red",
      }
    },
    "& .MuiTabs-root": {
      background: "#001E3A",
    },
    "& .MuiGrid-justify-xs-center": {
      width: "100% !important",
      padding: "5px",
    },
    "& .MuiDropzoneArea-root": {
      background: "#0A2034 !important",
    }
  },
  muDetailWrap: {
    display: "flex",
    padding: "8px 0",
    borderBottom: "1px solid #325679",
    background: "#1f364d",
  },

  uploadSaveButton: {
    padding: "15px 0 10px 0",
    textAlign: "right",
    "& button": {
      marginRight: "0px",
    }
  },

  globaltrackEdit: {
    "& .MuiFormControl-root": {
      border: "none",
      background: "#00405f",
      width: "100%",
      "&:focus": {
        border: "1px green solid",
      }
    },


  },

  emptyArtwork:{
    height:"115px !important",
  },
  imageAvatar: {
    height: "136px !important",
  },
  trackEditContainer: {
    position: "relative",
    "& button": {
      position: "absolute",
      right: "-14px",
      top: "6px",
      background: "#000",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      minWidth: "inherit",
      border: "1px solid #999",
      "& svg": {
        fontSize: "15px",
        color: "#fff",
      },
      "& span": {
        lineHeight: "1",
      }
    },
  },
  buttonCustomSize: {
    "& svg": {
      fontSize: "16px !important",
    },
  },
  commonTopButton: {
    padding: "9px",
    height: "32px",
    width: "32px",
    minWidth: "inherit",
    marginTop: "7px",
    marginLeft: "0px",
  },
  musicOrigin: {
    "& .MuiOutlinedInput-root": {
      padding: "10px !important",
      background: "#00405f",
      "& .MuiSelect-select:focus": {
        background: "none",
      }
    },
  },
  muTitle:{
    color: "#fff",
    width:" 100%",
    margin: "0",
    padding: "10px 15px 10px 30px",
    overflow: "hidden",
    fontSize: "0.88em",
    fontWeight: "500",
    textOverflow: 'ellipsis',
    whiteSpace: "nowrap",
  },
  editView: {
    background: "#1f364d  !important",
    "& .MuiPaper-root": {
      background: "#1f364d !important",
    },
    "& .MuiButton-label":{
      minWidth:"16px",
    },
    "& .MuiTabs-root": {
      background: "#102233 !important",
    },
    "& input": {
      background: "#374a5d  !important",
      fontSize: "0.8em !important",
    },
    // "& .MuiChip-root":{
    //   background:"#5a4b63!important",
    // },
    "& > div .MuiFormControl-root": {
      background: "#1f364d !important",
    },
    "& .MuiOutlinedInput-root": {
      background: "#43668a!important",
    },
    "& > .MuiPaper-root > button": {
      margin: "7px 10px 0px 0px",
      width:"35px",
      height:"35px",
    }
  },
  EditMCPS: {
    padding: "10px",
    height: "calc(100% - 80px)",
    overflow: "auto",
    position: "absolute",
    width: "100%",
    top: "0",
    overflowX: "hidden",
    background: "#1f364d",
    "& .MuiInputBase-root": {
      width: "100%",
    },
    "& .MuiSelect-select": {
      padding: "10px 32px 10px 10px",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    }
  },
  updateMOP: {
    margin: "10px 0 !important",
  },
  contributorContainer: {
    "& > div": {
      background: "#102233",
      padding: "1px 20px !important",
    }
  },
  contributorSaveButton: {
    padding: "15px 0 10px 0",
    textAlign: "right",
    "& button": {
      marginRight: "0px",
      marginTop: "10px",
      marginBottom: "10px",
    }
  },
  contributorItems: {
    background: "#1f4163",
    fontSize: "0.75em",
    padding: "10px !important",
    boxSizing: "border-box",
    marginBottom: "5px",
    display: "flex",
    alignItems: "center",
    "& button": {
      width: "32px",
      height: "32px",
      minWidth: "inherit",
    },
    "& > div": {
      whiteSpace: " nowrap",
      overflow: "hidden",
      "& > div": {
        whiteSpace: " nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "& span": {
          minWidth: "40px",
          display: " inline-block",
        }
      }
    }
  },
  contributorItemRemove: {
    background: "none",
    minWidth: "inherit",
    maxHeight: "33px !important",
  },

  nonEditable: {
    "& > div": {
      display: "block !important",
      padding: "10px !important",
      borderColor: "transparent !important",
      background: " #1b3044",
      borderRadius: "3px",
    }
  },
  searchWrapper:{
    display:"flex",
    alignItems:"center",
    marginBottom:"20px",
    "& .MuiTextField-root":{
      width: "50%",
    },
    "& .MuiOutlinedInput-input":{
    minHeight: "18px",
    padding:"8px 32px 8px 10px",
  
    },
    "& .MuiOutlinedInput-root":{
      marginRight:" 10px",
    },
    "& button":{
      height:"35px",
      margin:"0"
    }
  },
  
  searchPRSWrapper:{
    display:"flex",
    alignItems:"center",
    marginBottom:"20px",
    "& .MuiTextField-root":{
      width: "100%",
    },
    "& .MuiOutlinedInput-input":{
    minHeight: "18px",
    padding:"8px 32px 8px 10px",
  
    },
    "& .MuiOutlinedInput-root":{
      marginRight:" 10px",
    },
    "& button":{
      height:"35px",
      margin:"0"
    },
    "& .MuiInputLabel-shrink": {
      top: "2px !important",
      left: "0px",
      color:"#fff"
    },
    "& label": {
      fontSize: "0.75em",
      top: " -10px !important",
      left: "0px",
      textTransform: "none",
    },
  },
  progressnew:{
    color: "green",
    width: "40px!important",
    height: "40px!important",
    margin:"40px auto",
    position: "absolute",
    left: "0",
    right: "0",
    top:"120px"
  },
  prsButton:{
    background: "#0f79ad",
    color: "#fff",
    borderColor: "#0f79ad",    
    "&:hover":{
      background:"#1b8dc5",
      borderColor: "#0f79ad",   
      color: "#fff", 
    }
  },
  prsImported:{
     "& label":{
       color:"#0fadfb",
     }
  },
  chipsContainer:{
    width:"100%",
    "& .MuiFormControl-root":{
      width:"100%",
      background: "#2d2d2d",
    },
    "& .MuiOutlinedInput-root":{
      padding:"0",
      background: "#2d2d2d",
    },
    "& .MuiOutlinedInput-input":{
      margin:" 0",
      background: "#2d2d2d",
    },
    "& .MuiChip-root":{
      margin: "5px",
  },
  },
  gridOverFlowContainer:{
    overflow: "auto",
    height: "390px",
  },
  resetDataButton:{
    marginLeft:"10px !important",
  },
  globalBlockCreateBox: {
    marginBottom: "10px",
    "& > div": {
      padding: "5px 20px",
      display:"flex",
      width:"100%",
      boxSizing: "border-box",
    alignItems: "center",
    "& > span":{
      margin:" 0 10px 0 0",
    fontSize: "12px",
    color: "#d7d4d4",
    }
    },  
    "& .MuiTextField-root":{
      width:"100%",
    },
   
  },

});
